// extracted by mini-css-extract-plugin
module.exports = {"select-input":"select-input__1IccL","s":"s__1658k","card":"card__1lxpR","m":"m__gdZxI"};